import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AcknowledgementsService } from '../../../shared/services/acknowledgements/acknowledgements.service';
import { ClientStore } from '../../../shared/stores/client/client.store';

/**
 * Guard that checks for pending acknowledgements before allowing navigation.
 * If acknowledgements exist, redirects to the acknowledgements page.
 *
 * Assumes clientSetupGuard has already run and a client is available in the store.
 */
export const acknowledgementsGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const clientStore = inject(ClientStore);
  const acknowledgementsService = inject(AcknowledgementsService);
  const router = inject(Router);

  const client = clientStore.client()!;

  try {
    const acknowledgements = await firstValueFrom(
      acknowledgementsService.get(client.clientId, client.brokerageId)
    );

    if (acknowledgements && acknowledgements.length > 0) {
      return router.parseUrl('/acknowledgements');
    }

    return true;
  } catch (error) {
    console.error('Acknowledgements check failed', error);
    return true;
  }
};
